import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  downloadButton: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
  },
  downloadText: {
    color: theme.palette.primary.main,
    fontSize: 18,
    marginLeft: 8,
    fontWeight: 600,
  },
}));

export default useStyles;
